export interface KeycloakUser {
    exp: number;
    iat: number;
    auth_time: number;
    jti: string;
    iss: string;
    aud: string[];
    sub: string;
    typ: string;
    azp: string;
    nonce: string;
    session_state: string;
    acr: string;
    'allowed-origins': string[];
    realm_access: Access;
    resource_access: Record<string, Access>;
    scope: string;
    sid: string;
    email_verified: boolean;
    name: string;
    preferred_username: string;
    given_name: string;
    family_name: string;
    email: string;
}

export interface Access {
    roles: any[];
}
